import styled, { css } from 'styled-components';

export const Content = styled.div`
  box-sizing: border-box;
  position: absolute;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
  background-color: rgba(0, 0, 0, 0.9);
  top: 50px;
  right: 0px;
  padding: 15px;
  border-radius: 10px;

  z-index: 999;
  background-color: #5f6872;
  width: 280px;
  left: 0px;
  ${(props) =>
    props.$simple &&
    css`
      padding: 10px 0 0;
      background: none;
      position: static;
      top: auto;
      right: auto;
      border-radius: 0;
      left: auto;
      width: auto;
      box-shadow: none;
    `}
`;

export const Arrow = styled.div`
  position: absolute;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  top: -9px;
  left: 50px;
  border-bottom: 10px solid #5f6872;
`;

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
`;

export const Item = styled.div`
  height: ${(props) => props.height};
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: white;
  cursor: pointer;
  border-bottom: 0;
  padding: 8px 0;
`;
